import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class BacklogInitiativesInitiativeWorkstreamsRoute extends Route {
  async setupController(controller, model) {
    super.setupController(controller, model);
    model.tfos.then(() => {});
    // Keep the live EmberData ManyArray here (not a sorted copy) so newly
    // created/removed workstreams keep showing up without a reload — the
    // controller's `sortedWorkstreams` getter derives display order from it.
    model.workstreams.then((results) => controller.set('workstreams', results));
    model.weeks.then(() => {});
  }

  model() {
    return this.modelFor('backlog.initiatives.initiative');
  }
}

export default instrumentRoutePerformance(
  BacklogInitiativesInitiativeWorkstreamsRoute,
);
